module.exports = __webpack_public_path__ + "media/images/meeting_points/pin-location-7d49d7f9d7e7c75a02d663092a326e11.svg";